import { render, staticRenderFns } from "./ChartProfit.vue?vue&type=template&id=6d825146&scoped=true&"
import script from "./ChartProfit.vue?vue&type=script&lang=js&"
export * from "./ChartProfit.vue?vue&type=script&lang=js&"
import style0 from "./ChartProfit.vue?vue&type=style&index=0&id=6d825146&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d825146",
  null
  
)

export default component.exports